export const devModeSelector = (state: any) => state.devMode;

export const currencySelector = (state: any) => state.currency;

export const incrementalsSelector = (state: any) => state.incrementals;
export const upgradesSelector = (state: any) => state.upgrades;
export const tradesSelector = (state: any) => state.trades;

export const modalHexSelector = (state: any) => state.modalHex;
export const modalHexUpgradeSelector = (state: any) => state.modalHexUpgrade;

export const notificationsSelector = (state: any) => state.notifications;

export const tutorialSelector = (state: any) => state.tutorial;

export const realitySelector = (state: any) => state.reality;
export const prestigeSelector = (state: any) => state.prestige;
